var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E01912"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7746 15.44C28.9506 15.44 30.6893 16.0373 31.9906 17.232C33.3133 18.4267 33.9746 20.0587 33.9746 22.128C33.9746 24.2827 33.292 25.904 31.9266 26.992C30.5613 28.08 28.748 28.624 26.4866 28.624L26.3586 31.152H23.1906L23.0306 26.128H24.0866C26.156 26.128 27.7346 25.8507 28.8226 25.296C29.932 24.7413 30.4866 23.6853 30.4866 22.128C30.4866 20.9973 30.156 20.112 29.4946 19.472C28.8546 18.832 27.9586 18.512 26.8066 18.512C25.6546 18.512 24.748 18.8213 24.0866 19.44C23.4253 20.0587 23.0946 20.9227 23.0946 22.032H19.6706C19.6706 20.752 19.9586 19.6107 20.5346 18.608C21.1106 17.6053 21.932 16.8267 22.9986 16.272C24.0866 15.7173 25.3453 15.44 26.7746 15.44ZM24.7266 38.224C24.0653 38.224 23.5106 38 23.0626 37.552C22.6146 37.104 22.3906 36.5493 22.3906 35.888C22.3906 35.2267 22.6146 34.672 23.0626 34.224C23.5106 33.776 24.0653 33.552 24.7266 33.552C25.3666 33.552 25.9106 33.776 26.3586 34.224C26.8066 34.672 27.0306 35.2267 27.0306 35.888C27.0306 36.5493 26.8066 37.104 26.3586 37.552C25.9106 38 25.3666 38.224 24.7266 38.224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHelpIcon);
export default __webpack_public_path__ + "static/media/red-help-icon.3ca4e908f09247f884b0627503cea97a.svg";
export { ForwardRef as ReactComponent };